<template>
  <div class="counter">
    <div class="counter__number">
      {{ numberShow }}
    </div>
    <div class="counter__name">
      {{ name }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  
  name: "CounterItemAnimation",
  props: [ "name"],
  data() {
    return {
      numberShow: 0,
      interval: false,
      number: 0,
    };
  },
  created: function() {
  this.getData()
  },
  methods: {
    getData: function() {
         axios
        .get("https://api.rewolucyjna.pl/api/counter/rewolucyjna", {
          headers: {crossDomain: true},
        })
        .then((response) => {     
          this.number = response.data.counter;
            
        }).then(()=> {
            this.numberFn();
        });
    },
    numberFn: function() {
      clearInterval(this.interval);

      if (this.number == this.numberShow) {
        return;
      }

      this.interval = window.setInterval(
        function() {
          if (this.numberShow != this.number) {
            var change = (this.number - this.numberShow) / 10;

            change = change >= 0 ? Math.ceil(change) : Math.floor(change);

            this.numberShow = this.numberShow + change;
          }
        }.bind(this),
        20
      );
    },
  },
};
</script>
